import { memoizeWeakKey } from '@studio/utils/memoize';

import type { HybridHistory } from './hybridHistory';
import useHybridHistory from './useHybridHistory';
import { resolveLocation, type To } from './utils';

export interface HrefOptions {
  readonly pop?: boolean;
}

export type CreateHref = (to: To, options?: HrefOptions) => string;

const getCreateHref = memoizeWeakKey((history: HybridHistory): CreateHref => {
  return function createHref(to, options) {
    if (typeof to === 'string' && URL.canParse(to)) {
      return to;
    }

    const nextLocation = resolveLocation(history.location, to);

    const path = options?.pop
      ? history.createPopHref(nextLocation)
      : history.createHref(nextLocation);

    return new URL(path, document.baseURI).href;
  };
});

export default function useCreateHref(): CreateHref {
  const history = useHybridHistory();
  return getCreateHref(history);
}
